import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-663bafcc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "relative bg-gray-50 pt-[50%] overflow-hidden file-thumbnail" };
const _hoisted_2 = {
    key: 0,
    class: "hover-name text-white absolute bottom-2 left-2 image-hover-media"
};
const _hoisted_3 = {
    key: 1,
    class: "hover-option image-hover-media"
};
const _hoisted_4 = { class: "absolute inset-0 w-full h-full overflow-hidden rounded-t-lg file-thumbnail-inner" };
const _hoisted_5 = ["src"];
const _hoisted_6 = {
    key: 0,
    class: "px-2 py-2 file-name-container"
};
import { DotsVerticalIcon, Link02Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UIDropdown, UITextSmMedium, UITooltip, renderIcon, } from '@gohighlevel/ghl-ui';
import { truncate } from 'lodash';
import { computed, h, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import { useEvent } from '../composable/useEvent';
import { copyToClipboard } from '../util/helper';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DefaultFile',
    props: {
        file: {}
    },
    setup(__props) {
        const { t } = useI18n();
        const { sendNotification } = useEvent();
        const props = __props;
        const gradientStyle = computed(() => {
            return hover.value || hoverDropdown.value
                ? {
                    background: 'linear-gradient(0deg, rgba(34,34,34,1) 0%, rgba(255,255,255,0)  75%)',
                    'z-index': '1000',
                }
                : {};
        });
        const hover = ref(false);
        const hoverDropdown = ref(false);
        const onChangeOption = e => {
            hoverDropdown.value = false;
            switch (e) {
                case 'copy':
                    copyToClipboard(props.file.url);
                    sendNotification({
                        title: t('common.copiedClipboard'),
                        type: 'success',
                    });
                    break;
                default:
                    break;
            }
        };
        const contextMenuItems = [
            {
                name: t('common.getLink'),
                slug: 'link',
                icon() {
                    return h(renderIcon(Link02Icon), null, {});
                },
                label: 'Copy',
                key: 'copy',
            },
        ];
        const toggleDropdown = e => {
            hoverDropdown.value = !hoverDropdown.value;
            e.stopPropagation();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["relative overflow-hidden bg-white rounded-lg shadow-md group ring-1 ring-black ring-opacity-5", { 'hover-effect': hover.value }]),
                onMouseenter: _cache[1] || (_cache[1] = ($event) => (hover.value = true)),
                onMouseleave: _cache[2] || (_cache[2] = ($event) => (hover.value = false))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (hover.value || hoverDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_unref(UITooltip), null, {
                                trigger: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(truncate)(_ctx.file.name)), 1)
                                ]),
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.file.name), 1)
                                ]),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true),
                    (hover.value || hoverDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_unref(UIDropdown), {
                                options: contextMenuItems,
                                id: 'dropdown',
                                placement: "bottom",
                                onClickoutside: _cache[0] || (_cache[0] = ($event) => (hoverDropdown.value = false)),
                                show: hoverDropdown.value,
                                onSelect: onChangeOption
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIButton), {
                                        id: "media-file-dropdown",
                                        type: "default",
                                        size: "small",
                                        disabled: false,
                                        loading: false,
                                        ghost: false,
                                        quaternary: true,
                                        circle: false,
                                        text: false,
                                        onClick: toggleDropdown
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(DotsVerticalIcon), { class: "w-5 h-5 text-black cursor-pointer" })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["show"])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            class: "relative w-full h-full image-hover-media",
                            style: _normalizeStyle(gradientStyle.value)
                        }, null, 4),
                        _createElementVNode("img", {
                            src: _ctx.file.url,
                            alt: "",
                            class: "absolute inset-0 object-cover w-full h-full"
                        }, null, 8, _hoisted_5)
                    ])
                ]),
                false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_unref(UITextSmMedium), { class: "truncate" }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(UITooltip), null, {
                                    trigger: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(truncate)(_ctx.file.name)), 1)
                                    ]),
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.file.name), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true)
            ], 34));
        };
    }
});
